var styleDataHash = "80c92784";
const injectCss = () => {
  var css = `@charset "UTF-8";.glob_fontElementMap,.nFSBe{font-family:var(--ricos-font-family,unset)}.bKB4v{background-color:#fff;border-radius:var(--ricos-settings-whitebox-border-radius,2px);box-shadow:var(--ricos-settings-whitebox-box-shadow,0 4px 8px 0 rgba(0,0,0,.1),0 0 4px 0 rgba(0,0,0,.1));box-sizing:border-box;display:flex;flex-direction:column;gap:8px;max-height:360px;min-height:40px;overflow:hidden;overflow:auto;padding:8px 0}.bKB4v *,.bKB4v :after,.bKB4v :before{box-sizing:inherit}.bKB4v input{box-sizing:border-box}.T-FPL{align-items:center;align-self:center;color:var(--ricos-settings-text-color,var(--ricos-text-color,#212121));cursor:pointer;display:flex;font-family:var(--ricos-settings-text-font-family,Madefor,"Helvetica Neue",Helvetica,Arial,メイリオ,meiryo,"ヒラギノ角ゴ pro w3","hiragino kaku gothic pro",sans-serif);font-size:14px;gap:12px;justify-content:start;min-height:36px;padding-left:12px;padding-right:8px;width:220px}.T-FPL span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.T-FPL.u6Anb{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-fallback-color-tuple,0,0,0)),.06)}.T-FPL .oJavs{border-radius:50%;height:28px;min-height:28px;min-width:28px;overflow:hidden;width:28px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var mention_list_default = {
  "fontElementMap": "nFSBe",
  "mention_list": "bKB4v",
  "mention_item": "T-FPL",
  "mention_item_selected": "u6Anb",
  "avatar": "oJavs"
};
export {
  mention_list_default as default,
  injectCss
};
//# sourceMappingURL=mention-list-scss.js.map
